import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from '@/store/types'
import { mapaPeligro } from '@/store/modules/mapa-peligro'
import { pronosticoHidrico } from '@/store/modules/pronostico-hidrico'
import { pronosticoAire } from '@/store/modules/pronostico-aire'
import { puntosPeligro } from '@/store/modules/puntos-peligro'
import { pronosticoHidricoEstacion } from '@/store/modules/pronostico-hidrico-estacion'
import { pronosticoMeteorologico } from '@/store/modules/pronostico-meteorologico'
import { pronosticoLocalMapas } from '@/store/modules/pronostico-local-mapas'
import { googleMaps } from '@/store/modules/google-maps'
import { imagenesSatelitales } from '@/store/modules/imagenes-satelitales'
import { estaciones } from '@/store/modules/estaciones'
import { account } from '@/store/modules/account'
import { alerts } from '@/store/modules/alerts'
import { pronosticoHistorico } from '@/store/modules/pronostico-historico'
import { minutasPronostico } from '@/store/modules/minutas-pronostico'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
    mapaPeligro: undefined,
    pronosticoHidrico: undefined,
    pronosticoAire: undefined,
    pronosticoHidricoEstacion: undefined,
    pronosticoMeteorologico: undefined,
    pronosticoLocalMapas: undefined,
    googleMaps: undefined,
    imagenesSatelitales: undefined,
    estaciones: undefined,
    account: undefined,
    alerts: undefined,
    pronosticoHistorico: undefined,
    minutasPronostico: undefined,
    puntosPeligro: undefined
  },
  modules: {
    mapaPeligro,
    pronosticoHidrico,
    pronosticoAire,
    pronosticoHidricoEstacion,
    pronosticoMeteorologico,
    pronosticoLocalMapas,
    googleMaps,
    imagenesSatelitales,
    estaciones,
    account,
    alerts,
    pronosticoHistorico,
    minutasPronostico,
    puntosPeligro
  }
}

const storeInstance = new Vuex.Store<RootState>(store)

export default storeInstance
